export default window._cmsContent['solar/solar-panels']